import { Paper, Typography } from '@mui/material';
import { vySerialize, withNewOptionalValue, isEmptyString, withDefault } from '@vy/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { useTablePagination } from '../../../hooks/use-table-pagination';
import { usePageFiltersPersistence } from '../../../hooks/use-page-filters-persistence';
import { usePaginationResetHandler } from '../../../hooks/use-pagination-reset-handler';
import { PaymentsOverviewTable } from './PaymentsOverviewTable';
import { usePaymentsFilters } from './payments-page-hooks/use-payments-filters';
import { usePaymentsNew } from '../../../hooks/requests/use-payments-new';
import { useTableSorting } from '../../../hooks/use-table-sorting';
import { PAYMENTS_QUERY_SEARCH_PARAM_KEY } from './payments-page-hooks/use-query-input-param-consts';

const PAYMENTS_PERSISTED_FILTER_PARAMS = ['paymentFilters', PAYMENTS_QUERY_SEARCH_PARAM_KEY] as const;

const PaymentsPageContent: React.FC = () => {
  const filters = usePaymentsFilters();
  const { currentSortModel } = useTableSorting();
  const { page, pageSize, onPageChange, onPageSizeChange } = useTablePagination();

  const { data: paymentsResponse, isFetching } = usePaymentsNew({
    page,
    pageSize,
    search: isEmptyString(filters.queryParam) ? undefined : filters.queryParam,
    paymentFilters: vySerialize(filters.allFiltersForApi),
    sort: withNewOptionalValue(currentSortModel, vySerialize),
  });

  const payments = withDefault(paymentsResponse?.items, []);

  usePaginationResetHandler(withDefault(paymentsResponse?.count, 0));

  usePageFiltersPersistence(PAYMENTS_PERSISTED_FILTER_PARAMS);

  return (
    <>
      <Helmet>
        <title>Payments</title>
      </Helmet>
      <VyLayout
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            fontSize: 24,
            padding: 1.5
          }}>
          Payments
        </Typography>

        <Paper
          variant="outlined"
          sx={(theme) => ({
            borderRadius: '12px',
            boxShadow: theme.shadows[1],
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          })}
        >
          <PaymentsOverviewTable
            filters={filters}
            loadingItems={isFetching}
            items={payments}
            itemsCount={withDefault(paymentsResponse?.count, 0)}
            page={page}
            pageSize={pageSize}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </Paper>
      </VyLayout>
    </>
  );
};

const PaymentsPage = withGlobalSearchParams(withSuspenseBoundary(PaymentsPageContent));
export { PaymentsPage };
